<template>
  <v-simple-table fixed-header height="300px" class="item-list-table">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Fullname
          </th>
          <th class="text-left">
            DOB
          </th>
          <th class="text-left">
            Relationship
          </th>
          <th class="text-left">
            Insurance No.
          </th>
          <th class="text-left">
            Issue Date
          </th>
          <th class="text-left">
           Exp. Date
          </th>
          <th class="text-left">
            Status
          </th>
        </tr>
      </thead>

      <tbody v-if="dependent_list">
        <tr v-for="item in dependent_list" :key="item.id">
          <td>{{ item.firstname }} {{ item.lastname }}</td>
          <td>{{ item.dob | formatShortDate }}</td>
          <td>{{ item.relationship }}</td>
          <td>{{ item.insurance_no }}</td>
          <td>{{ item.insurance_iss_date | formatShortDate }}</td>
          <td>{{ item.insurance_exp_date | formatShortDate }}</td>
          <td>{{ item.insurance_status ? "ACTIVE" : "INACTIVE" }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
// /import { createNamespacedHelpers } from "vuex";
//import { CommonServices } from "../../services/common.services";


export default {
  props: ["dependent_list"],
  data: () => ({
    dialog: false,
    items: null,
    employee_id: null,
    menu: false,
    modal: false,
    valid: true,
    errors: null,
    slug: "slug",
    error: false,
    desserts: [
      {
        name: "Frozen Yogurt",
        calories: 159
      },
      {
        name: "Ice cream sandwich",
        calories: 237
      },
      {
        name: "Eclair",
        calories: 262
      }
    ]
  }),
  computed: {
    /*...vesselNamespace.mapState({
      vessels: state => state.vessels
    })*/
  },
  watch: {
    dialog(val) {
      //if (val) this.initiate();
    }
  },

  mounted() {
    //this.start_up();
    //this.getVessels();
    this.initiate();
  },
  methods: {
    //...departedVesselName.mapActions(["addDepartedVessel"]),

    dirty() {},
    initiate() {
      //
      // console.log("initiate from item list props", this.do_items_list);
      /*  console.log(
        "initiate from item list from state",
        this.delivery_order.do_items
      );*/
      /* console.log(
        "initiate from item list from state",
        this.delivery_order_items
      );*/
    },

    close() {
      this.dialog = false;
    }
  }
};
</script>

<style scoped>

</style>
